var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Grid, Select } from 'semantic-ui-react';
import { CustomPriceRow } from "../../admin/CustomPriceRow";
import FieldWithErrorDisplay from "../../FieldWithErrorDisplay";
import { Help } from "../../Help";
import { Pmol } from "../rna-cish/RnaCatalog";
import { priceColumn, PriceDisplay } from "./EditKitForm";
import { FreeTextAmpLabel, } from "./KitModel";
var HcrAmplifierForm = /** @class */ (function (_super) {
    __extends(HcrAmplifierForm, _super);
    function HcrAmplifierForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.priceDisplay = function () {
            return React.createElement(PriceDisplay, { priceCents: _this.props.priceCents, loading: _this.props.priceLoading });
        };
        _this.onScaleChange = function (_, data) {
            var v = data.value;
            var newScale = _this.currentScales().find(function (s) { return s.valuePmol === v; });
            if (newScale === undefined) {
                if (!_this.props.enableCustomScale) {
                    throw new RangeError("Unknown scale value " + v);
                }
                if (typeof v !== 'string') {
                    throw new Error("Invalid scale " + v);
                }
                var num = parseInt(v, 10);
                if (num === undefined || isNaN(num)) {
                    throw new Error("Invalid scale " + v);
                }
                newScale = new Pmol(num);
            }
            _this.props.onAmpStateChange({
                scale: newScale
            }, _this.props.onUserSelection);
        };
        _this.onLabelChange = function (_, data) {
            var val = data.value;
            if (typeof val !== 'string') {
                throw new RangeError("Unexpected label value type: " + val);
            }
            var currentAmpLabelCatalog = _this.props.catalog.channels.find(function (a) { return a.hcrAmplifier.id === _this.props.ampState.hcrAmplifier.id; });
            if (currentAmpLabelCatalog == null) {
                throw new Error("Unexpected amplifier value type: " + _this.props.ampState.hcrAmplifier.id);
            }
            if (val.startsWith('id:')) {
                var idStr_1 = val.substring('id:'.length);
                var newLabel = currentAmpLabelCatalog.labels.combined
                    .find(function (l) { return l.label.id === idStr_1; });
                if (newLabel === undefined) {
                    throw new RangeError("Unknown label value " + val);
                }
                var oldScale_1 = _this.props.ampState.scale;
                var update = void 0;
                // if the scale exists for the new label
                if (newLabel.scales.findIndex(function (s) { return s.valuePmol === oldScale_1.valuePmol; }) >= 0) {
                    // then use it
                    update = {
                        label: newLabel.label,
                    };
                }
                else {
                    // we transitioned from custom, or otherwise from a scale that this label doesn't support
                    var scale = void 0;
                    if (["B6", "B7", "B8", "B9", "B10"].includes(_this.props.ampState.hcrAmplifier.id)) {
                        scale = _this.props.catalog.freeTextLabelScales[0];
                    }
                    else {
                        scale = newLabel.defaultScale;
                    }
                    update = {
                        label: newLabel.label,
                        scale: scale
                    };
                }
                _this.props.onAmpStateChange(update, _this.props.onUserSelection);
            }
            // if it's not an id, someone added a new entry; onAddFreeTextLabel will be called
        };
        _this.onAmplifierChange = function (_, data) {
            var valStr = data.value;
            var catalog = _this.props.catalog.channels.find(function (a) {
                return a.hcrAmplifier.id === valStr;
            });
            if (catalog === undefined) {
                throw new RangeError("Invalid amplifier " + valStr);
            }
            var update;
            if (["B6", "B7", "B8", "B9", "B10"].includes(catalog.hcrAmplifier.id)) {
                var scale = _this.props.catalog.freeTextLabelScales
                    .find(function (s) { return s.valuePmol === _this.props.ampState.scale.valuePmol; });
                update = scale ? {
                    hcrAmplifier: catalog.hcrAmplifier,
                    label: catalog.defaultLabel.label
                } :
                    {
                        hcrAmplifier: catalog.hcrAmplifier,
                        scale: _this.props.catalog.freeTextLabelScales[0],
                        label: catalog.defaultLabel.label
                    };
            }
            else {
                update = { hcrAmplifier: catalog.hcrAmplifier, label: catalog.defaultLabel.label };
            }
            _this.props.onAmpStateChange(update, _this.props.onUserSelection);
        };
        _this.onCustomPriceChange = function (newStateFn, callback) {
            _this.props.onAmpStateChange(function (oldState) { return ({ customPrice: newStateFn(oldState.customPrice) }); }, callback);
        };
        _this.currentScales = function () {
            var _a, _b;
            var label = _this.props.ampState.label;
            var ampSixToTen = ["B6", "B7", "B8", "B9", "B10"].includes(_this.props.ampState.hcrAmplifier.id);
            var scales;
            if (label instanceof FreeTextAmpLabel || ampSixToTen) {
                scales = _this.props.catalog.freeTextLabelScales;
            }
            else {
                scales = (_b = (_a = _this.props.catalog.channels.find(function (a) {
                    return a.hcrAmplifier.id === _this.props.ampState.hcrAmplifier.id;
                })) === null || _a === void 0 ? void 0 : _a.labels.combined.find(function (l) {
                    return l.label.id === label.id;
                })) === null || _b === void 0 ? void 0 : _b.scales;
                if (scales === undefined) {
                    throw new RangeError("Invalid Label: " + label);
                }
            }
            // don't mess with the arrays in the catalog
            scales = Array.from(scales);
            if (_this.props.enableCustomScale) {
                // if custom things are allowed, create an extra entry if need be
                if (scales.findIndex(function (p) { return p.valuePmol === _this.props.ampState.scale.valuePmol; }) < 0) {
                    scales.push(new Pmol(_this.props.ampState.scale.valuePmol));
                }
            }
            scales.sort(function (s1, s2) { return s1.valuePmol - s2.valuePmol; });
            return scales;
        };
        return _this;
    }
    HcrAmplifierForm.labelValue = function (l) {
        if (l instanceof FreeTextAmpLabel) {
            return "free-text:" + l.name;
        }
        return "id:" + l.id;
    };
    HcrAmplifierForm.prototype.render = function () {
        var _this = this;
        var scaleOptions = this.currentScales().map(function (s) {
            var numberOfTubes = calculateNumOfTubesForAmp(s.valuePmol);
            var numberOfSlides = calculateNumOfSlidesForAmp(s.valuePmol);
            var volumeLabel = _this.props.legacy ? s.valueWithUnit : s.ampConcentratedWithUnit;
            if (_this.props.selectedSampleType.id === 'WHOLE_MOUNT' || _this.props.selectedSampleType.id === 'CELLS_SUSPENSION') {
                return {
                    text: React.createElement(React.Fragment, null,
                        numberOfTubes,
                        " tubes",
                        React.createElement("span", { className: "description" }, volumeLabel)),
                    content: React.createElement(React.Fragment, null,
                        numberOfTubes,
                        " tubes",
                        React.createElement("span", { className: "description" }, volumeLabel)),
                    value: s.valuePmol
                };
            }
            else if (_this.props.selectedSampleType.id === 'TISSUE_SECTION' || _this.props.selectedSampleType.id === 'CELLS_SLIDE') {
                return {
                    text: React.createElement(React.Fragment, null,
                        numberOfSlides,
                        " slides",
                        React.createElement("span", { className: "description" }, volumeLabel)),
                    content: React.createElement(React.Fragment, null,
                        numberOfSlides,
                        " slides",
                        React.createElement("span", { className: "description" }, volumeLabel)),
                    value: s.valuePmol
                };
            }
            else {
                return {
                    text: React.createElement(React.Fragment, null, volumeLabel),
                    content: React.createElement(React.Fragment, null, volumeLabel),
                    value: s.valuePmol
                };
            }
        });
        var freeTextOption = [];
        if (this.props.ampState.label instanceof FreeTextAmpLabel) {
            freeTextOption.push({
                text: this.props.ampState.label.name,
                value: HcrAmplifierForm.labelValue(this.props.ampState.label)
            });
        }
        var labelLabel = this.props.legacy ? React.createElement(React.Fragment, null,
            "Label ",
            React.createElement(Help, null,
                React.createElement("p", null, "For multiplex experiments, choose a different fluorophore label (647, 594, \u2026) for each HCR\u2122 Amplifier (v3.0) that will be imaged in the same sample (e.g., B1-647, B2-594, \u2026)."))) : React.createElement(React.Fragment, null,
            "Label ",
            React.createElement(Help, null,
                React.createElement("p", null, "For multiplex experiments, choose a different label (647, 546, \u2026) for each amplifier that will be imaged in the same sample (e.g., X3-647, X2-546, \u2026)."),
                React.createElement("p", null, "For flexibility, amplifiers X1, X2, and X3 are available with multiple label options (488, 546, 647), while for expanded multiplexing, amplifiers X4\u2013X10 are each available with one label option. We recommend using a longer-wavelength label (e.g., 647 or 750) for targets that are more difficult to detect (e.g., low-expression target), as autofluorescence tends to be higher in shorter-wavelength channels (e.g., 405 or 488).")));
        var scaleLabel = this.props.legacy ? React.createElement(React.Fragment, null,
            "Scale ",
            React.createElement(Help, null,
                "The standard reaction concentration of each HCR\u2122 Amplifier (v3.0) hairpin is 60 nM. The HCR\u2122 Amplifier (v3.0) scale depends on the reaction volume and the number of experiments. For example, for a 100 \u03BCL reaction volume, each experiment will require 6 pmol of each hairpin, so 600 pmol amplifier scale corresponds to 100 experiments.",
                React.createElement("br", null),
                React.createElement("br", null),
                "For the following sample types, recommended reaction volumes are:",
                this.props.experimentVolumeTable)) : React.createElement(React.Fragment, null,
            "Scale ",
            React.createElement(Help, null,
                "The default HCR\u2122 Gold Amplifier scale is 200 \u00B5L.  For different sample types, representative reaction volumes and corresponding amplifier scale and number of experiments are:",
                this.props.experimentVolumeTable));
        var currentAmpLabelCatalog = this.props.catalog.channels.find(function (c) {
            return c.hcrAmplifier.id === _this.props.ampState.hcrAmplifier.id;
        });
        if (currentAmpLabelCatalog == null) {
            throw new RangeError("Invalid Amplifier " + this.props.ampState.hcrAmplifier.id);
        }
        var labelOptions = freeTextOption
            .concat(currentAmpLabelCatalog.labels.combined
            .sort(function (a, b) { return a.label.name.localeCompare(b.label.name); })
            .map(function (l) { return ({
            // match left spacing from custom icon
            text: React.createElement(React.Fragment, null,
                React.createElement("span", null, l.label.name)),
            content: React.createElement(React.Fragment, null,
                React.createElement("span", null, l.label.name)),
            value: HcrAmplifierForm.labelValue(l.label),
        }); }));
        var amplifierDropdownText = function () {
            return _this.props.catalog.channels.map(function (a) {
                var compatibleLabels = a.labels.combined.map(function (l) { return l.label.name; }).sort();
                return {
                    text: React.createElement(React.Fragment, null,
                        a.hcrAmplifier.id,
                        React.createElement("span", { className: "description" }, !_this.props.legacy && compatibleLabels.length > 0 ? "" + compatibleLabels.join(", ") : "")),
                    value: a.hcrAmplifier.id
                };
            });
        };
        return React.createElement(Grid, { columns: 4, stackable: true },
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/amplifierComponent/hcrAmplifier', errors: this.props.errors, labelContent: this.props.amplifierLabel, labelFor: 'amp-hcr-amplifier', showErrors: this.props.showErrors },
                        React.createElement(Select, { className: "label-dropdown", disabled: this.props.hcrAmplifierDisabled, value: this.props.ampState.hcrAmplifier.id, onChange: this.onAmplifierChange, options: amplifierDropdownText(), name: 'amp-hcr-amplifier' }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/amplifierComponent/label', errors: this.props.errors, labelContent: labelLabel, labelFor: 'amp-label', showErrors: this.props.showErrors },
                        React.createElement(Select, { name: 'amp-label', className: labelOptions.length <= 1 ? "deactivated-dropdown" : "selection-dropdown", onChange: this.onLabelChange, options: labelOptions, value: HcrAmplifierForm.labelValue(this.props.ampState.label), search: true, scrolling: false, icon: labelOptions.length <= 1 ? false : undefined }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/amplifierComponent/scalePmol', errors: this.props.errors, labelContent: scaleLabel, labelFor: 'amp-scale', showErrors: this.props.showErrors },
                        React.createElement(Select, { name: 'amp-scale', className: "label-dropdown", value: this.props.ampState.scale.valuePmol, allowAdditions: this.props.enableCustomScale, onChange: this.onScaleChange, options: scaleOptions, search: true }))),
                priceColumn(this.priceDisplay())),
            this.props.enableCustomPrice &&
                React.createElement(CustomPriceRow, { customPrice: this.props.ampState.customPrice, defaultEffectivePriceCents: this.props.priceCents, errorPathPrefix: '/amplifierComponent', errors: this.props.errors, onPriceChange: this.onCustomPriceChange, onUserInput: this.props.onUserSelection }));
    };
    return HcrAmplifierForm;
}(React.PureComponent));
export { HcrAmplifierForm };
export var calculateNumOfTubesForAmp = function (valuePmol) {
    return Math.round(valuePmol / 30);
};
export var calculateNumOfSlidesForAmp = function (valuePmol) {
    return Math.round(valuePmol / 6);
};
//# sourceMappingURL=HcrAmplifierForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/rna-fish/HcrAmplifierForm.js
// module id = 285
// module chunks = 0